import React from "react";
import { useFieldArray } from "react-hook-form";
import { FieldSet } from "src/components/event_transaction/components/shared/Form/FieldSet";
import { Text } from "src/components/ui/Text";
import { AddIcon, DeleteIcon } from "src/components/event_transaction/icons";
import clsx from "clsx";
import { IconButton } from "src/components/ui/baseButton";
import { groupOptionPosition } from "./groupOptionData";

const AuthorsAndContributorListsForm = (props) => {
  const { control, watch, disabled, defaultAuthorsAndContributorList } = props;
  const watchFieldArray = watch("authorsAndContributorList");

  const {
    fields: authorsAndContributorList,
    append: appendAuthorsAndContributorList,
    remove: removeAuthorsAndContributorList,
  } = useFieldArray({ name: "authorsAndContributorList", control });

  const controlledFields = authorsAndContributorList.map((field, index) => ({
    ...field,
    ...watchFieldArray?.[index],
  }));

  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-end gap-2">
        <Text variant="bold-14">List of Authors and Contributors</Text>
        <Text variant="normal-10">
          Please enter the name, position, email, and phone number of the
          authors
        </Text>
      </div>

      <div className="flex flex-col gap-2">
        {controlledFields.map((item, index) => {
          return (
            <div
              key={item?.id}
              className={`flex gap-2 items-center relative ${clsx(
                authorsAndContributorList.length > 1 && "pr-10"
              )}`}
            >
              <FieldSet
                disabled={disabled}
                name={`authorsAndContributorList.${index}.name`}
                type="text"
                control={control}
                label="First Name - Last Name"
                placeholder={
                  !disabled ? "Please enter first name and last name" : ""
                }
              />

              <FieldSet
                disabled={disabled}
                name={`authorsAndContributorList.${index}.position`}
                type="autocomplete"
                control={control}
                label="Position"
                groupOptions={groupOptionPosition}
                placeholder={!disabled ? "Please select position" : ""}
              />

              {authorsAndContributorList.length > 1 && !disabled ? (
                <IconButton
                  className="absolute right-0 top-[0.55rem] cursor-pointer hover:bg-red-50 rounded w-8 h-8"
                  onClick={() => removeAuthorsAndContributorList(index)}
                >
                  <img src={DeleteIcon} alt="deleteIcon" className="w-5 h-5" />
                </IconButton>
              ) : (
                ""
              )}
            </div>
          );
        })}

        {!disabled && (
          <div
            className="w-full h-full pr-3 bg-white rounded-md border border-quinary px-2 py-4 flex gap-2 items-center cursor-pointer"
            onClick={() =>
              appendAuthorsAndContributorList(defaultAuthorsAndContributorList)
            }
          >
            <img src={AddIcon} alt="addIcon" className="w-3 h-3" />
            <Text variant="normal-14" className="">
              Add more authors and contributors
            </Text>
          </div>
        )}
      </div>
    </div>
  );
};

export default AuthorsAndContributorListsForm;
